import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstDischargeSummaryFormService {
  mstDischargeSummaryForm: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mst_discharge_summary_form/list/?';
  private DeListRecord = webapi + 'mst_discharge_summary_form/deactivated_list/?';
  private AddRecord = webapi + 'mst_discharge_summary_form/create';
  private EditRecord = webapi + 'mst_discharge_summary_form/update';
  private GetRecord = webapi + 'mst_discharge_summary_form/byid/';
  private DeleteRecord = webapi + 'mst_discharge_summary_form/delete/';
  private ReActiveRecord = webapi + 'mst_discharge_summary_form/reActive/';

    private AddDsfField = webapi + 'mst_dsf_field/create';
    private GetDsfFieldList = webapi + 'mst_dsf_field/getfieldlistbydsfid/';
    private GetByDsfIdFieldId = webapi + 'mst_dsf_field/getbydsfidfieldid/';
    private EditDsfFieldRecord = webapi + 'mst_dsf_field/update';

    constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    editDsfFieldRecordService(model: any) {
        return this.http.put(this.EditDsfFieldRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
    return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordDsfFieldListService(id: any) {
    return this.http.get(this.GetDsfFieldList + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getRecordByDsfIdFieldId(dfsId: any, fieldId ) {
    return this.http.get(this.GetByDsfIdFieldId + dfsId + '/' + fieldId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    addRecordDsfFieldService(model: any) {
        return this.http.post(this.AddDsfField, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-discharge-summary-form/mst-discharge-summary-form.service.ts